import { Container } from '@material-ui/core';
import React from 'react';

const Jackpot = () => {
  return (
    <Container align='center'>
      

    </Container>
  );
};

export default Jackpot;
